module.exports = __webpack_public_path__ + "static/img/brees-2005-img-in-copy.d83c135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-img-in-copy.jpg
// module id = 4XTu
// module chunks = 1